import { eEstadoMaestro } from "../common/enumModel";
import { ICategoriaHipoModel } from "../interfaces/categoria-hipo/ICategoriaHipoModel";

export class CategoriaHipoModel implements ICategoriaHipoModel {
    
    idCategoriaHipo : number;
    nombre : string;
    idEstado: eEstadoMaestro;
    estado: string;
    
    constructor(){
        this.idCategoriaHipo = 0;
        this.nombre = '';
        this.idEstado = eEstadoMaestro.ACTIVO;
        this.estado = '';
    }
}